/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import { Autocomplete, Box, Button, Card, CardContent, FormControl, InputAdornment, InputLabel, MenuItem, Modal, Select, TextField, Tooltip, Typography } from "@mui/material";
import Grid from "@mui/material/Grid";
import TimelineItem from "components/Icon/TimelineItem";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { appConstants } from "utils/appConstants";
import { BTable } from "components/BTable/BTable";
import { loadingAction } from "ReduxReducers/loadingReducer";
import { useMaterialUIController } from "context";
import PageTitle from "examples/PageTitle/PageTitle";
import { createTheme } from "react-data-table-component";
import { useDispatch } from "react-redux";
import { getCutomerInvoiceStatement } from "utils/invoiceAPI";
import { getScreenRight } from "utils/generic";
import { GridSearchIcon } from "@mui/x-data-grid";
import { getColorMappings } from "components/ColorComponent/ColorComponent";
import MDButton from "components/MDButton";
import { formatCurrencyAUD } from "utils/formatCurrency";

const SCREEN_NAME = "Activity Statement";
let SCREEN_RIGHT;
let res = {};
createTheme(
    'solarized',
    {
        text: {
            primary: 'white',
            secondary: 'white',
        },
        background: {
            default: '#202940',
        },
        context: {
            background: '#202940',
            text: 'white',
        },
        divider: {
            default: 'white',
        },
        //   button: {
        //     default: '#2aa198',
        //    hover: 'rgba(0,0,0,.08)',
        //    focus: 'rgba(255,255,255,.12)',
        //  disabled: 'rgba(255, 255, 255, .34)',
        // },
        sortFocus: {
            default: '#2aa198',
        },
    },
    'dark',
);
createTheme(
    'light',
    {
        text: {
            primary: 'black',
            secondary: 'black',
        },
        background: {
            default: 'white',
        },
        context: {
            background: 'white',
            text: 'black',
        },
        divider: {
            default: 'gray',
        },
        sortFocus: {
            default: '#2aa198',
        },
    },
    'dark',
);

function ActivityStatement() {
    const { id } = useParams()
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [controller] = useMaterialUIController();
    const [perPage, setPerPage] = useState(10);
    const [rows, setRows] = useState([]);
    const [totalRows, setTotalRows] = useState(0);
    const [toggleCleared, setToggleCleared] = useState(false);
    const { darkMode, sidenavColor } = controller;
    const [loginDetails, setLoginDetails] = useState(JSON.parse(sessionStorage.getItem("LOGIN_DETAILS")));
    const [token, setToken] = useState(sessionStorage.getItem("TOKEN"));
    const [values, setValues] = useState({
        _id: id,
        sortingType: "",
        sortingField: "",
        page: 1,
        filterValues: "",
        status: "All",
        limit: appConstants.limit,
        searchParameterList: ['invoiceNumber', 'purchaseOrderNumber', 'invoiceDate', 'paidDate', 'dueAmount', 'totalAmount', 'status'],
        businessUserID: JSON.parse(sessionStorage.getItem("LOGIN_DETAILS"))?.businessUserID,
        token: token,
        themeID: ""
    });
    const { barColor, tableBorder } = getColorMappings(sidenavColor);
    const [screenAccess, setScreenAccess] = useState(false);
    const [screenName, setScreenName] = useState("Activity Statements");
    useEffect(() => {
        const fetchStatementData = async () => {
            try {
                setLoginDetails(JSON.parse(sessionStorage.getItem("LOGIN_DETAILS")));
                await getRight();
                if (id !== undefined) {
                    fetchCutomerInvoiceStatementData()
                }

            } catch (error) {
                console.error("Error in useEffect:", error);
            }
        };
        fetchStatementData();
    }, [values.status, perPage]);

    async function getRight() {
        SCREEN_RIGHT = await getScreenRight(SCREEN_NAME);
        setScreenAccess(SCREEN_RIGHT === 'Full Access' ? true : false);
    }

    const fetchCutomerInvoiceStatementData = async () => {
        values.perPage = perPage;
        getCutomerInvoiceStatement(values, (data) => {
            if (res) {
                setRows(data.Result_Output.docs);
                setTotalRows(data.Result_Output.totalDocs)
                setScreenName("Activity Statement " + "(" + (data.Result_Output.docs[0].customerName) + ")");
            }
        }, dispatch)
    }

    const handleSearchFilter = (event) => {
        setValues({ ...values, filterValues: event.target.value });
    };

    const handleSort = async (type, value) => {
        values.sortingType = value;
        values.sortingField = type;
        await fetchCutomerInvoiceStatementData();
    };

    const handlePageChange = page => {
        values.page = page;
        fetchCutomerInvoiceStatementData();
    };

    const handlePerRowsChange = async (newPerPage, page) => {

        dispatch(loadingAction(true));
        values.page = page;
        values.limit = newPerPage;
        setPerPage(newPerPage);
        dispatch(loadingAction(false));
    };
    const handleNavigate = () => {
        navigate("/invoices");
    }
    let columns = [
        {
            name: <p style={{ fontSize: "12px" }}>Invoice Number</p>,
            selector: row => <span style={{ fontSize: "12px", textAlign: "start" }}>{row.invoiceNumber}</span >,
            sortable: true,
            sortField: 'invoiceNumber',
        },
        {
            name: <p style={{ paddingLeft: "12px", fontSize: "12px", }}>Reference</p>,
            selector: row => <span style={{ fontSize: "12px" }}>{row.purchaseOrderNumber}</span>,
            sortable: true,
            sortField: 'purchaseOrderNumber',
            center: "true",
        },
        {
            name: <p style={{ paddingLeft: "12px", fontSize: "12px" }}>Issue Date</p>,
            selector: row => <span style={{ fontSize: "12px" }}>{row.invoiceDate}</span >,
            sortable: true,
            sortField: 'invoiceDate',
            center: "true",
        },
        {
            name: <p style={{ paddingLeft: "12px", fontSize: "12px" }}>Paid Date</p>,
            selector: row => <span style={{ fontSize: "12px" }}>{row.paidDate}</span>,
            sortable: true,
            sortField: 'paidDate',
            center: "true",
        },
        {
            name: <p style={{ paddingLeft: "12px", fontSize: "12px" }}>Due Amount</p>,
            selector: row => <span style={{ fontSize: "12px" }}>{row.dueAmount}</span>,
            sortable: true,
            sortField: 'dueAmount',
            center: "true",
        },
        {
            name: <p style={{ paddingLeft: "12px", fontSize: "12px" }}>Total</p>,
            selector: row => <span style={{ fontSize: "12px" }}>{formatCurrencyAUD(row.totalAmount)}</span>,
            sortable: true,
            sortField: 'totalAmount',
            center: "true",
        },
        {
            name: <p style={{ paddingLeft: "12px", fontSize: "12px" }}>Status</p>,
            selector: row => <span style={{ fontSize: "12px" }}>{row.status}</span>,
            sortable: true,
            sortField: 'status',
            center: "true",
        },
    ];

    return (
        <DashboardLayout>
            <DashboardNavbar />
            <div style={{ marginTop: '20px' }}>
                <Card color="primary">
                    <PageTitle screenName={screenName} />
                    <Grid container display={"flex"} px={2} justifyContent="end" mt={2} gap={2} >
                        <Grid item lg={2.5} xs={6} >
                            <FormControl fullWidth>
                                <InputLabel id="Status">Filter By Status</InputLabel>
                                <Select
                                    labelId="demo-simple-select-label"
                                    id="demo-simple-select"
                                    style={{ height: "38.11px" }}
                                    label="Filter By Status"
                                    value={values.status}
                                    onChange={(e) => setValues({ ...values, status: e.target.value })}
                                >
                                    <MenuItem value="All">All</MenuItem>
                                    <MenuItem value="Paid">Paid Payment</MenuItem>
                                    <MenuItem value="Partial Paid">Partial Payment</MenuItem>
                                    <MenuItem value="Unpaid">Awaiting Payment</MenuItem>
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid lg={2.5} xs={6}>
                            <TextField
                                type="text"
                                variant="outlined"
                                fullWidth
                                className="searchButton"
                                placeholder="Search..."
                                label="Search Filter"
                                value={values.filterValues}
                                onChange={handleSearchFilter}
                                onKeyUp={(e) => {
                                    if (e.key === "Enter") fetchCutomerInvoiceStatementData();
                                }}
                                InputProps={{
                                    endAdornment: (
                                        <InputAdornment  >
                                            <Button style={{ borderRadius: "0px 0.5rem  0.5rem 0px", boxShadow: "none", background: barColor }} variant="contained" onClick={fetchCutomerInvoiceStatementData}>
                                                <GridSearchIcon color="white" />
                                            </Button>
                                        </InputAdornment>
                                    ),
                                }}
                            />
                        </Grid>
                        <MDButton
                            variant="contained"
                            color="success"
                            style={{ height: "38.11px" }}
                            onClick={handleNavigate}
                        >
                            Back
                        </MDButton>
                    </Grid>
                    <CardContent>
                        <BTable
                            columns={columns}
                            data={rows}
                            sortingType={handleSort}
                            sortServer
                            pagination
                            paginationServer
                            paginationTotalRows={totalRows}
                            onChangeRowsPerPage={handlePerRowsChange}
                            onChangePage={handlePageChange}
                            clearSelectedRows={toggleCleared}
                            fixedHeaderScrollHeight="410px"
                            fixedHeader={true}
                        />
                    </CardContent>
                </Card>
            </div >

        </DashboardLayout >
    );

}

export default ActivityStatement;
